/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "actions";
import UserShopTrack from "components/widgets/user/UserShopTrack";
import "components/elements/main/index.scss";
import { checkUserAllowed } from "helpers/utils.js";


const UserShopsPageTrack = (props) => {

  const [state] = useState({
    layoutColumns: 3,
  });


    useEffect(() => {
    document.getElementById("color").setAttribute("href", "#");
  }, []);

    return (
        <div>
            <UserShopTrack {...props} colSize={state.layoutColumns} />
        </div>
    );

};

UserShopsPageTrack.propTypes = {
    userMainResetSearchShops: PropTypes.func.isRequired,
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
};

// Mapping Props and State.
const userShopsPageTrack = connect(
  ({ userMainShops, bootupInfo }) => ({
    bootupInfo,
      userDetails: bootupInfo.userDetails,
    reqStatus: userMainShops.reqStatus,
    isLoading: userMainShops.isLoading,
    serviceError: userMainShops.serviceError,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(UserShopsPageTrack);

export { userShopsPageTrack as default };
